

export const notify = (text="Thank you for trying! Enjoy the rest of the day!") => {

	let notif = document.getElementById('notification')
	let textcontainer = notif.getElementsByTagName('p')[0] //take the first one which is the only one

	//then change the text of the notification p to the imported text
	textcontainer.textContent = text;

	//now pop the notification up
	notif.classList.add('pop');

	//wait 6 secs and remove it
	setTimeout(()=>{notif.classList.remove('pop')}, 6000)
}
